import type {Author} from "~/repository/types";
import { useTaxCalculation } from "~/composables/useTaxCalculation";
import { useTaxStore } from "~/stores/tax";

const PAID_STATUS = 'complete'
type ProductType = "subscribe" | "one-time-payment"

interface Product {
    type: ProductType
}

export class Subscribe implements Product {
    type: ProductType = "subscribe"
    author: Author

    constructor(profile: Author) {
        this.author = profile
    }
}

export class OneTimePayment implements Product {
    type: ProductType = 'one-time-payment'
    price: Number
    username: String
    currency_code: String
    netPrice: Number

    constructor(price: Number, username: String, currency_code: String) {
        // Store net price for future calculations
        this.netPrice = price
        // Calculate tax using the tax calculation composable
        const { total } = useTaxCalculation(Number(price), 'post')
        // Use the calculated total price (which already includes tax)
        this.price = total.value
        this.currency_code = currency_code
        this.username = username
    }
}

export const usePaymentStore = defineStore('payment', () => {

    const currentInitPaymentRequest = ref({
        url: null,
        body: null
    })

    const currentProduct: Ref<Product | null> = ref(null);

    async function init(url: string, body: Object, product: Product) {
        currentInitPaymentRequest.value = {
            url,
            body
        }
        currentProduct.value = product;
    }

    async function confirm(paymentId: string, paymentIntent: string) {
        const driver = 'stripe'
        const {data} = await $larafetch(`payment/${paymentId}/confirm/${driver}`, {
            method: 'put',
            body: {
                intent: paymentIntent
            }
        })
        return data.status == PAID_STATUS
    }

    function clear() {
        currentProduct.value = null
        currentInitPaymentRequest.value = {
            url: null as unknown as string,
            body: null as unknown as Object
        }
    }


    return {
        currentProduct,
        currentInitPaymentRequest,
        init,
        confirm,
        clear
    }

})